import axios from 'axios';

export const FETCH_SHOWCASES = 'FETCH_SHOWCASES';
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const SELECTED_CATEGORY = 'SELECTED_CATEGORY';
export const SEARCH_TERM = 'SEARCH_TERM';
export const SEARCH_CHANGE_NUMBER = 'SEARCH_CHANGE_NUMBER';
export const FETCH_DISCLAIMER = 'FETCH_DISCLAIMER';
export const PER_PAGE = 'PER_PAGE';
export const PAGE_NUMBER = 'PAGE_NUMBER';
export const TOTAL_PAGES = 'TOTAL_PAGES';
export const TOTAL_RESULTS = 'TOTAL_RESULTS';
export const SELECTED_BADGE = 'SELECTED_BADGE';
export const FETCH_BADGES = 'FETCH_BADGES';

const CancelToken = axios.CancelToken;
let cancel;

global.categoryArr = [];
global.badgeArr = [];

export function fetchShowcasesDispatch( selectedCategory = [], selectedBadge = [], searchTerm = '', perPage = 99, pageNum = 1 ) {
	if ( cancel !== undefined ) {
		cancel();
	}

	//checks array
	if ( selectedCategory && Array.isArray( selectedCategory ) && selectedCategory.length > 0 ) {
		selectedCategory = selectedCategory.toString();
	}

	//checks array
	if ( selectedBadge && Array.isArray( selectedBadge ) && selectedBadge.length > 0 ) {
		selectedBadge = selectedBadge.toString();
	}

	return ( dispatch ) => {
		'use strict';
		let params = '?_embed', orderBy = 'title';

		if ( searchTerm.length > 0 ) {
			orderBy = 'relevance';
		}

		//REST limit is 100 for performance, any more will need pagination
		let url = `${ wpApiSettings.root }${ wp.api.versionString }member-showcase${ params }&per_page=${ perPage }&page=${ pageNum }&order=asc&orderby=${ orderBy }&showcase-categories=${ selectedCategory }&showcase-badges=${ selectedBadge }&search=${ searchTerm }`;

		//to prevent "bad request" due to empty taxonomy (from WP 5.8 upgrade)
		if ( selectedCategory.length === 0 ) {
			//REST limit is 100 for performance, any more will need pagination
			url = `${ wpApiSettings.root }${ wp.api.versionString }member-showcase${ params }&per_page=${ perPage }&page=${ pageNum }&order=asc&orderby=${ orderBy }&showcase-badges=${ selectedBadge }&search=${ searchTerm }`;
		}

		return axios( {
			              method     : 'GET',
			              url        : url,
			              cancelToken: new CancelToken( c => cancel = c )
		              } ).then( response => {
			dispatch( {
				          type: FETCH_SHOWCASES, payload: response.data
			          } );

			dispatch( {
				          type   : TOTAL_PAGES,
				          payload: response.headers[ 'x-wp-totalpages' ]
			          } );
			dispatch( {
				          type   : TOTAL_RESULTS,
				          payload: response.headers[ 'x-wp-total' ]
			          } );
		} ).catch( err => {
			//console.log( err, 'request cancelled' );
		} );
	};
}

export function fetchCategoriesDispatch() {
	//shows up to 50 categories, could change so per_page is dynamic if we have more than 50...
	return ( dispatch ) => {
		axios.get( `${ wpApiSettings.root }wp/v2/showcase-categories?per_page=50` )
		     .then( response => {
			     dispatch( {
				               type: FETCH_CATEGORIES, payload: response.data
			               } );
		     } );
	};
}

export function handleSelectedCategoryDispatch( selectedCategory ) {
	if ( global.categoryArr.includes( selectedCategory ) ) {
		global.categoryArr.pop( selectedCategory );
		return ( dispatch ) => {
			'use strict';
			dispatch( {
				          type: SELECTED_CATEGORY, payload: global.categoryArr
			          } );
		};
	}

	/* empty array first before adding new category (can be removed if you want to select multiple filters at once */
	global.categoryArr = [];
	global.categoryArr.push( selectedCategory );
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: SELECTED_CATEGORY, payload: global.categoryArr
		          } );
	};
}

export function fetchBadgesDispatch() {
	return ( dispatch ) => {
		axios.get( `${ wpApiSettings.root }isda/v1/member-showcase-badge-meta` )
		     .then( response => {
			     dispatch( {
				               type: FETCH_BADGES, payload: response.data
			               } );
		     } );
	};
}

export function handleSelectedBadgeDispatch( selectedBadge ) {
	if ( global.badgeArr.includes( selectedBadge ) ) {
		global.badgeArr.pop( selectedBadge );
		return ( dispatch ) => {
			'use strict';
			dispatch( {
				          type: SELECTED_BADGE, payload: global.badgeArr
			          } );
		};
	}

	/* empty array first before adding new badge (can be removed if you want to select multiple filters at once */
	global.badgeArr = [];
	global.badgeArr.push( selectedBadge );

	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: SELECTED_BADGE, payload: badgeArr
		          } );
	};
}

export function changeNumberDispatch( changeNumber ) {
	return ( dispatch ) => {
		dispatch( {
			          type: SEARCH_CHANGE_NUMBER, payload: changeNumber
		          } );
	};
}

export function handleSearchDispatch( searchTerm ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: SEARCH_TERM, payload: searchTerm
		          } );
	};
}

export function fetchDisclaimerDispatch() {
	return ( dispatch ) => {
		'use strict';
		const url = `${ wpApiSettings.root }isda/v1/member-showcase-disclaimer`;
		axios.get( url ).then( response => {
			dispatch( {
				          type: FETCH_DISCLAIMER, payload: response.data
			          } );
		} );
	};
}

export function setPageNumberDispatch( pageNum ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: PAGE_NUMBER, payload: pageNum
		          } );
		dispatch( {
			          type: FETCH_SHOWCASES, payload: []
		          } );
	};
}
